module.exports = __webpack_public_path__ + "fonts/Gilroy-Bold.0607a1b.woff";